import { useContext } from 'react';
import { MeContext, MeContextData } from './context';

export function useMe(): MeContextData {
    const data = useContext<MeContextData | undefined>(MeContext);

    if (!data) {
        throw new Error(
            "MeContextData unavailable. Are you sure you're using this in a nested component of an MeProvider?"
        );
    }

    return data;
}
